<template>
	<div id="Property_Result" class="property-results">
		<dir class="wrapped-details">
			<div class="results-top-sec">
				<div class="header5">Neighborhood</div>
				<div class="header3">Analysis Results</div>
			</div>
			<AssesmentIcon />
			<div>
				<div class="paragraph other-prop-text">
					We found {{ property.lowerAssessmentCount }} properties in your area with assessment per square foot rates lower than yours. See
					sumary of our findings below:
				</div>
				<div class="bars">
					<AssessmentProgressBar
						v-for="(bar, index) in assessmentProgressBars"
						v-bind:key="bar.label"
						:index="index"
						:value="bar.percent"
						:percent="(bar.percent / getLargestValue(assessmentProgressBars)) * 100"
						:label="bar.label"
						metric="/ SqFt"
					/>
				</div>
			</div>
			<div class="last-note" v-if="isOverassessed">
				A successful appeal could save you up to {{ property.savingAmount | toCurrency }} in savings on your annual tax bill.
			</div>
			<div class="last-note" v-if="isFairlyassessed">
				Good News! You are not being over assessed. Based on our analysis your property taxes are currently in line with your neighbors.
			</div>
		</dir>

		<SubscriptionAndForms />
	</div>
</template>

<script>
import AssessmentProgressBar from "@/components/ui/AssessmentProgressBar.vue";
import AssesmentIcon from "@/components/property/AssesmentIcon.vue";
import SubscriptionAndForms from "@/components/property/SubscriptionAndForms.vue";
import { assessmentStatus } from "@/env";

export default {
	name: "property-results",
	components: {
		AssessmentProgressBar,
		AssesmentIcon,
		SubscriptionAndForms,
	},
	props: {
		assesmentRating: String,
	},
	computed: {
		property() {
			return this.$store.getters.getAllPropertyData;
		},
		isOverassessed() {
			return this.$store.getters.getAssessmentRate == assessmentStatus.overAssessed;
		},
		isFairlyassessed() {
			if (this.$store.getters.getAssessmentRate == assessmentStatus.fairlyAssessed) {
				return true;
			} else if (this.$store.getters.getAssessmentRate == assessmentStatus.underassessed) {
				return true;
			} else {
				return false;
			}
		},
		assessmentProgressBars() {
			return this.$store.getters.getAllPropertyData.assessmentProgress;
		},
	},
	methods: {
		getLargestValue(data) {
			return data.reduce((max, b) => Math.max(max, b.percent), data[0].percent);
		},
	},
};
</script>

<style scoped lang="scss">
.property-results {
	text-align: left;
	max-width: 1600px;
	padding: 60px;
	margin: 0 auto;
	.results-top-sec {
		display: flex;
		flex-direction: column;
	}
	.last-note {
		font-size: 24px;
		text-align: center;
		line-height: 40px;
		color: var(--black);
		align-self: center;
	}
	.header5 {
		color: var(--accent);
	}
	.header3 {
		font-size: 36px;
		line-height: 36px;
		color: var(--black);
		margin-top: 8px;
	}
	.header2 {
		font-size: 51px;
		line-height: 100%;
		color: var(--black);
	}
	.paragraph {
		color: var(--text);
	}
	.assessment-progress-bar {
		margin-top: 0.9em;
	}
	.conditional-text {
		width: 602px;
		margin-top: 43px;
	}
	.wrapped-details {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(550px, 1fr));
		grid-gap: 18px 45px;
		// margin-top: 35px;
		padding-left: unset;
		.bars {
			max-width: 620px;
		}
	}
	.subscription-and-forms {
		display: grid;
		grid-column: span 2;
		max-width: unset;
		margin-top: 80px;
	}
}
@media screen and (max-width: 768px) {
	.property-results {
		height: unset;
	}
}
@media screen and (max-width: 414px) {
	.property-results {
		padding: 35px 15px;
		.wrapped-details {
			display: grid;
			// grid-template-columns: repeat(auto-fit, minmax(370px, 1fr));
			grid-template-columns: 1fr;
		}
	}
}
</style>
